import React from "react";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import { toast } from 'react-toastify';
import CONSTANT from "./../../constant";
import ModalWindow from "../common/ModalWindow";
import ChangePassword from "./ChangePassword";

import { onChange, setOptions, validateForm, getCookie, getProfilePictureUrl } from "./../../utils";
import {
  getDepartmentList,
  getGradeList,
  getGroupList,
  getDesignationList,
  getUnitList,
  getUserType,
  getLoginStatus,
  getPermissionList,
  getLeaveAvailingStatus,
} from "./../../actions/MasterAction";
import { getUserSummaryList, uploadProfilePictureByAdmin } from "./../../actions/UserAction";
import { adminResetPassword } from "../../actions/AuthAction";
import moment from "moment";

class ComponentName extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const daysOfWeek = [
      { code: 0, name: "Sunday" },
      { code: 1, name: "Monday" },
      { code: 2, name: "Tuesday" },
      { code: 3, name: "Wednesday" },
      { code: 4, name: "Thursday" },
      { code: 5, name: "Friday" },
      { code: 6, name: "Saturday" },
    ];

    const detail = props.detail ? props.detail.detail : undefined;
    const contactList = props.detail ? props.detail.contactList : [];
    const permissionList = props.detail
      ? props.detail.permissionList.map((i: any) => i.code)
      : [];
    const ud = getCookie(CONSTANT.cookie.userDetail);

    const weeklyOffDetail =
      detail && detail.weeklyOff
        ? detail.weeklyOff.split(",").map((i: any) => {
            const code = parseFloat(i);
            return {
              code,
              name: daysOfWeek.filter((j: any) => j.code === code)[0].name,
            };
          })
        : [];

    this.state = {
      code: props.code,
      departmentCode: {
        name: "departmentCode",
        value: detail ? detail.departmentCode : "",
        options: [],
        error: "",
        isRequired: true,
      },
      gradeCode: {
        name: "gradeCode",
        value: detail ? detail.gradeCode : "",
        options: [],
        error: "",
        isRequired: true,
      },
      groupCode: {
        name: "groupCode",
        value: detail ? detail.groupCode : "",
        options: [],
        error: "",
        isRequired: true,
      },
      designationCode: {
        name: "designationCode",
        value: detail ? detail.designationCode : "",
        options: [],
        error: "",
        isRequired: true,
      },
      unitCode: {
        name: "unitCode",
        value: detail ? detail.unitCode : "",
        options: [],
        error: "",
        isRequired: true,
      },
      fileCreationDepartments: {
        name: "fileCreationDepartments",
        value: detail?.fileCreationDepartments || [],
        options: [],
        error: "",
        isRequired: false,
      },

      fileCreationDesignations: {
        name: "fileCreationDesignations",
        value: detail?.fileCreationDesignations || [],
        options: [],
        error: "",
        isRequired: false,
      },

      fileCreationUnits: {
        name: "fileCreationUnits",
        value: detail?.fileCreationUnits || [],
        options: [],
        error: "",
        isRequired: false,
      },
      reportingManagerCode: {
        name: "reportingManagerCode",
        value:
          detail && detail.reportingManagerCode
            ? detail.reportingManagerCode
            : "",
        options: [],
        error: "",
        isRequired: true,
      },
      userTypeCode: {
        name: "userTypeCode",
        value: detail
          ? detail.userTypeCode
          : CONSTANT.static.userType.user.code,
        options: [],
        error: "",
        isRequired: true,
      },
      loginStatusCode: {
        name: "loginStatusCode",
        value: detail ? detail.loginStatusCode : "",
        error: "",
        isRequired: true,
        options: [],
      },
      leaveAvailingStatusCode: {
        name: "leaveAvailingStatusCode",
        value: detail ? detail.leaveAvailingStatusCode : "",
        error: "",
        isRequired: true,
        options: [],
      },

      employeeNumber: {
        name: "employeeNumber",
        value: detail ? detail.employeeNumber : "",
        error: "",
        isRequired: true,
      },
      isHOD: {
        name: "isHOD",
        value: detail ? detail.isHOD : false,
        error: "",
        isRequired: true,
      },
      isApprovingAuthority: {
        name: "isApprovingAuthority",
        value:
          detail && detail.isApprovingAuthority
            ? detail.isApprovingAuthority
            : false,
        error: "",
        isRequired: true,
      },
      name: {
        name: "name",
        value: detail ? detail.name : "",
        error: "",
        isRequired: true,
      },
      email: {
        name: "email",
        value: detail ? detail.email : "",
        error: "",
        isRequired: false,
      },
      mobile: {
        name: "mobile",
        value: detail ? detail.mobile : "",
        error: "",
        isRequired: false,
      },
      profilePicture: {
        name: "profilePicture",
        value: detail ? detail.profilePicture : "",
        error: "",
        isRequired: false,
      },
      dob: {
        name: "dob",
        value:
          detail && detail.dob
            ? moment(detail.dob, "MM/DD/YYYY").format("YYYY-MM-DD")
            : "",
        error: "",
        isRequired: true,
      },
      doj: {
        name: "doj",
        value: detail && detail.doj ? detail.doj.substr(0, 10) : "",
        error: "",
        isRequired: false,
      },
      contactList: {
        name: "contactList",
        value: contactList,
        error: "",
        isRequired: false,
        options: [],
      },
      permissionList: {
        name: "permissionList",
        value: permissionList,
        error: "",
        isRequired: false,
        options: [],
      },
      weeklyOff: {
        name: "weeklyOff",
        value: weeklyOffDetail,
        error: "",
        isRequired: false,
        options: daysOfWeek,
      },
      academicQualifications: {
        name: "academicQualifications",
        value: detail ? detail.academicQualifications : "",
        error: "",
        isRequired: false,
      },
      postHeldName: {
        name: "postHeldName",
        value: detail ? (detail.postHeld || detail.postHeldName || "") : "",
        error: "",
        isRequired: false,
      },
      postHeldGrade: {
        name: "postHeldGrade",
        value: detail ? (detail.postGrade || detail.postHeldGrade || "") : "",
        error: "",
        isRequired: false,
      },
      continuousAppointmentDate: {
        name: "continuousAppointmentDate",
        value: detail && detail.continuousAppointmentDate
          ? detail.continuousAppointmentDate.substr(0, 10)
          : "",
        error: "",
        isRequired: false,
      },
      presentPay: {
        name: "presentPay",
        value: detail ? (detail.presentPayScale || detail.presentPay || "") : "",
        error: "",
        isRequired: false,
      },
      sameEnterpriseAppointmentDate: {
        name: "sameEnterpriseAppointmentDate",
        value: detail && (detail.enterpriseAppointmentDate || detail.sameEnterpriseAppointmentDate)
          ? (detail.enterpriseAppointmentDate || detail.sameEnterpriseAppointmentDate).substr(0, 10)
          : "",
        error: "",
        isRequired: false,
      },
      firstPublicEnterpriseAppointmentDate: {
        name: "firstPublicEnterpriseAppointmentDate",
        value: detail && (detail.firstPublicEnterpriseDate || detail.firstPublicEnterpriseAppointmentDate)
          ? (detail.firstPublicEnterpriseDate || detail.firstPublicEnterpriseAppointmentDate).substr(0, 10)
          : "",
        error: "",
        isRequired: false,
      },
      firstAppointmentPayScale: {
        name: "firstAppointmentPayScale",
        value: detail ? detail.firstAppointmentPayScale : "",
        error: "",
        isRequired: false,
      },
      ud,
      showModal: false,
      profilePictureUrl: getProfilePictureUrl(detail?.profilePicture || ''),
      uploadingPicture: false,
    };
    this.onMultiChange = this.onMultiChange.bind(this);
  }

  componentDidMount() {
    getDepartmentList().then((res: any) => {
      setOptions(
        this,
        this.state.departmentCode.name,
        res.result.sort(this.onCompare)
      );
    });

    getGradeList().then((res: any) => {
      setOptions(
        this,
        this.state.gradeCode.name,
        res.result.sort(this.onCompare)
      );
    });

    getGroupList().then((res: any) => {
      setOptions(
        this,
        this.state.groupCode.name,
        res.result.sort(this.onCompare)
      );
    });

    getDesignationList(1).then((res: any) => {
      setOptions(
        this,
        this.state.designationCode.name,
        res.result.sort(this.onCompare)
      );
    });

    getUnitList().then((res: any) => {
      setOptions(
        this,
        this.state.unitCode.name,
        res.result.sort(this.onCompare)
      );
    });

    getUserType().then((res: any) => {
      const { ud } = this.state;
      if (ud.userTypeCode === CONSTANT.static.userType.superAdmin.code) {
        setOptions(this, this.state.userTypeCode.name, res.result);
      } else {
        const result = res.result.filter(
          (i: any) => i.code !== CONSTANT.static.userType.superAdmin.code
        );
        setOptions(this, this.state.userTypeCode.name, result);
      }
    });

    getLoginStatus().then((res: any) => {
      setOptions(this, this.state.loginStatusCode.name, res.result);
    });

    getLeaveAvailingStatus().then((res: any) => {
      setOptions(this, this.state.leaveAvailingStatusCode.name, res.result);
    });

    getUserSummaryList().then((res: any) => {
      res.result.push({ code: 0, name: "Self" });
      setOptions(this, this.state.reportingManagerCode.name, res.result);
      setOptions(this, this.state.contactList.name, res.result);
    });

    getPermissionList().then((res: any) => {
      setOptions(this, this.state.permissionList.name, res.result);
    });
  }

  onProfilePictureChange = (e: any) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      toast.error('Please select a valid image file (JPEG or PNG)');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error('Image size should be less than 5MB');
      return;
    }

    const { code } = this.state;
    if (!code) {
      // For new user, just show a preview (upload happens on save)
      const previewUrl = URL.createObjectURL(file);
      this.setState({ profilePictureUrl: previewUrl });
      return;
    }

    this.setState({ uploadingPicture: true });
    uploadProfilePictureByAdmin(code, file).then((res: any) => {
      this.setState({ uploadingPicture: false });
      if (res && res.status === CONSTANT.static.apiStatus.success) {
        this.setState({ profilePictureUrl: getProfilePictureUrl(res.result.profilePicture) });
        toast.success('Profile picture updated successfully');
      } else if (res) {
        toast.error(res.error || 'Failed to upload profile picture');
      }
    }).catch(() => {
      this.setState({ uploadingPicture: false });
      toast.error('Failed to upload profile picture');
    });
  }

  onMultiChange(e: any) {
    const { name, options } = e.target;

    const selectedValues = Array.from(options)
      .filter((opt: any) => opt.selected)
      .map((opt: any) => opt.value);

    this.setState((prev: any) => ({
      [name]: {
        ...prev[name],
        value: selectedValues,
        error: "",
      },
    }));
  }

  render() {
    const {
      code,
      employeeNumber,
      isHOD,
      isApprovingAuthority,
      name,
      email,
      mobile,
      dob,
      doj,
      contactList,
      departmentCode,
      gradeCode,
      groupCode,
      designationCode,
      unitCode,
      userTypeCode,
      reportingManagerCode,
      loginStatusCode,
      leaveAvailingStatusCode,
      academicQualifications,
      postHeldName,
      postHeldGrade,
      continuousAppointmentDate,
      presentPay,
      sameEnterpriseAppointmentDate,
      firstPublicEnterpriseAppointmentDate,
      firstAppointmentPayScale,
    } = this.state;
    const { permissionList, weeklyOff } = this.state;
    const { showModal, ud, profilePictureUrl, uploadingPicture } = this.state;

    return (
      <div className="row">
        {showModal && (
          <ModalWindow title="Change password" toggleModal={this.onCloseModal}>
            <ChangePassword userCode={code} onSubmit={this.onChangePassword} />
          </ModalWindow>
        )}
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              {code &&
                ud.userTypeCode ===
                  CONSTANT.static.userType.superAdmin.code && (
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        type="button"
                        className="btn btn-link float-right"
                        onClick={this.onShowModal}
                      >
                        Change Password
                      </button>
                    </div>
                  </div>
                )}
              <form onSubmit={this.onSubmit}>
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 24 }}>
                      <div style={{ flexShrink: 0 }}>
                        {profilePictureUrl ? (
                          <img
                            src={profilePictureUrl}
                            alt="Profile"
                            style={{
                              width: 120,
                              height: 120,
                              borderRadius: '50%',
                              objectFit: 'cover',
                              border: '3px solid #dee2e6',
                              display: 'block'
                            }}
                          />
                        ) : (
                          <div style={{
                            width: 120,
                            height: 120,
                            borderRadius: '50%',
                            backgroundColor: '#e9ecef',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 42,
                            fontWeight: 600,
                            color: '#6c757d',
                            border: '3px solid #dee2e6'
                          }}>
                            {name.value ? name.value.charAt(0).toUpperCase() : '?'}
                          </div>
                        )}
                      </div>
                      <div>
                        <label
                          className="btn submit-button btn-sm mb-0"
                          style={{ cursor: 'pointer', padding: '8px 20px', fontSize: 14 }}
                        >
                          {uploadingPicture ? 'Uploading...' : (code ? 'Upload Photo' : 'Select Photo')}
                          <input
                            type="file"
                            accept="image/jpeg,image/png"
                            style={{ display: 'none' }}
                            onChange={this.onProfilePictureChange}
                            disabled={uploadingPicture}
                          />
                        </label>
                        <p style={{ fontSize: 12, color: '#6c757d', marginBottom: 0, marginTop: 8 }}>
                          JPEG or PNG, max 5MB
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Employee #</label>
                      <input
                        type="text"
                        className={
                          employeeNumber.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        placeholder="Employee number"
                        name={employeeNumber.name}
                        value={employeeNumber.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Is department HOD?</label>
                      <select
                        value={isHOD.value}
                        className={
                          isHOD.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={isHOD.name}
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Is Approving Authority?</label>
                      <select
                        value={isApprovingAuthority.value}
                        className={
                          isApprovingAuthority.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={isApprovingAuthority.name}
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>User Type</label>
                      <select
                        value={userTypeCode.value}
                        className={
                          userTypeCode.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={userTypeCode.name}
                      >
                        <option value="">Please select User type</option>
                        {userTypeCode.options.map(
                          (item: any, index: number) => {
                            return (
                              <option key={index} value={item.code}>
                                {item.name}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Employee Name</label>
                      <input
                        type="text"
                        className={
                          name.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        placeholder="Name of the employee"
                        name={name.name}
                        value={name.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Employee Email</label>
                      <input
                        type="email"
                        className={
                          email.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        placeholder="Email of the employee"
                        name={email.name}
                        value={email.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Employee Mobile</label>
                      <NumberFormat
                        maxLength={10}
                        allowNegative={false}
                        type="text"
                        className={
                          mobile.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        placeholder="Mobile number of the employee"
                        name={mobile.name}
                        value={mobile.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>DOB</label>
                      <input
                        type="date"
                        className={
                          dob.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name={dob.name}
                        value={dob.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Department</label>
                      <select
                        value={departmentCode.value}
                        className={
                          departmentCode.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={departmentCode.name}
                      >
                        <option value="">Please select a department</option>
                        {departmentCode.options.map(
                          (item: any, index: number) => {
                            return (
                              <option key={index} value={item.code}>
                                {item.name}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Designation</label>
                      <select
                        value={designationCode.value}
                        className={
                          designationCode.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={designationCode.name}
                      >
                        <option value="">Please select a Designation</option>
                        {designationCode.options.map(
                          (item: any, index: number) => {
                            return (
                              <option key={index} value={item.code}>
                                {item.name}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Grade</label>
                      <select
                        value={gradeCode.value}
                        className={
                          gradeCode.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={gradeCode.name}
                      >
                        <option value="">Please select a grade</option>
                        {gradeCode.options.map((item: any, index: number) => {
                          return (
                            <option key={index} value={item.code}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Group</label>
                      <select
                        value={groupCode.value}
                        className={
                          groupCode.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={groupCode.name}
                      >
                        <option value="">Please select a group</option>
                        {groupCode.options.map((item: any, index: number) => {
                          return (
                            <option key={index} value={item.code}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Unit</label>
                      <select
                        value={unitCode.value}
                        className={
                          unitCode.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={unitCode.name}
                      >
                        <option value="">Please select a unit</option>
                        {unitCode.options.map((item: any, index: number) => {
                          return (
                            <option key={index} value={item.code}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Reporting Manager</label>
                      <select
                        value={reportingManagerCode.value}
                        className={
                          reportingManagerCode.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={reportingManagerCode.name}
                      >
                        <option value="">
                          Please select a reporting manager
                        </option>
                        {reportingManagerCode.options.map(
                          (item: any, index: number) => {
                            return (
                              <option key={index} value={item.code}>
                                {item.name}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group d-none">
                      <label>DOB</label>
                      <input
                        type="date"
                        className={
                          dob.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name={dob.name}
                        value={dob.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group d-none">
                      <label>DOJ</label>
                      <input
                        type="date"
                        className={
                          doj.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name={doj.name}
                        value={doj.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Login Status</label>
                      <select
                        value={loginStatusCode.value}
                        className={
                          loginStatusCode.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={loginStatusCode.name}
                      >
                        <option value="">
                          Please select User login status
                        </option>
                        {loginStatusCode.options.map(
                          (item: any, index: number) => {
                            return (
                              <option key={index} value={item.code}>
                                {item.name}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Availing Leave ?</label>
                      <select
                        value={leaveAvailingStatusCode.value}
                        className={
                          leaveAvailingStatusCode.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={this.onChange}
                        name={leaveAvailingStatusCode.name}
                      >
                        <option value="">
                          Please select User leave status
                        </option>
                        {leaveAvailingStatusCode.options.map(
                          (item: any, index: number) => {
                            return (
                              <option key={index} value={item.code}>
                                {item.name}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Contact list</label>
                      <Typeahead
                        flip={true}
                        id="ta-contact-list"
                        labelKey={(option: any) =>
                          `${option.name} (${option.employeeNumber})`
                        }
                        name={contactList.name}
                        selected={contactList.value}
                        multiple={true}
                        options={contactList.options}
                        onChange={(e: any) =>
                          this.typeaheadOnChange(contactList.name, e)
                        }
                        placeholder="list of people whom the user can contact"
                        isInvalid={contactList.error.length > 0}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Weekly off</label>
                      <Typeahead
                        flip={true}
                        id="ta-weekly-off"
                        labelKey={(option: any) => `${option.name}`}
                        name={weeklyOff.name}
                        selected={weeklyOff.value}
                        multiple={true}
                        options={weeklyOff.options}
                        onChange={(e: any) =>
                          this.typeaheadOnChange(weeklyOff.name, e)
                        }
                        placeholder="Set weekly off days"
                        isInvalid={weeklyOff.error.length > 0}
                      />
                    </div>
                  </div>
                </div>

                {ud.userTypeCode ===
                  CONSTANT.static.userType.superAdmin.code && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        {permissionList.options.map(
                          (item: any, index: number) => {
                            const isChecked =
                              permissionList.value.indexOf(item.code) > -1;
                            return (
                              <React.Fragment key={index}>
                                <div className="form-check">
                                  <label className="form-check-label">
                                    <input
                                      name={permissionList.name}
                                      value={item.code}
                                      onChange={this.onChange}
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={isChecked}
                                    />
                                    {item.name}
                                  </label>
                                </div>
                              </React.Fragment>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row mt-3">
                  <h1 className="fs-5 pb-2">Academic & Service Details</h1>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Academic & Professional Qualifications</label>
                      <textarea
                        className="form-control"
                        name={academicQualifications.name}
                        value={academicQualifications.value}
                        onChange={this.onChange}
                        placeholder="Brief academic and professional qualifications"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name of the Post Held</label>
                      <input
                        type="text"
                        className="form-control"
                        name={postHeldName.name}
                        value={postHeldName.value}
                        onChange={this.onChange}
                        placeholder="Enter post name"
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Grade of the Post</label>
                      <input
                        type="text"
                        className="form-control"
                        name={postHeldGrade.name}
                        value={postHeldGrade.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Date of Continuous Appointment in this Post</label>
                      <input
                        type="date"
                        className="form-control"
                        name={continuousAppointmentDate.name}
                        value={continuousAppointmentDate.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Present Pay & Pay Scale</label>
                      <input
                        type="text"
                        className="form-control"
                        name={presentPay.name}
                        value={presentPay.value}
                        onChange={this.onChange}
                        placeholder="e.g. 56100 - 177500"
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Date of Continuous Appointment in Same Enterprise</label>
                      <input
                        type="date"
                        className="form-control"
                        name={sameEnterpriseAppointmentDate.name}
                        value={sameEnterpriseAppointmentDate.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Date of First Public Enterprise Appointment</label>
                      <input
                        type="date"
                        className="form-control"
                        name={firstPublicEnterpriseAppointmentDate.name}
                        value={firstPublicEnterpriseAppointmentDate.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Scale of Pay on First Appointment</label>
                      <input
                        type="text"
                        className="form-control"
                        name={firstAppointmentPayScale.name}
                        value={firstAppointmentPayScale.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                </div>



                <div className="row">

                  <h1 className="fs-5 pb-2">Role-Based File Creation</h1>
                </div>

                <div className="row">
                  {/* Grade */}
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Grade</label>
                      <Typeahead
                        id="unit-typeahead"
                        multiple
                        labelKey="name"
                        options={this.state.unitCode?.options || []}
                        placeholder="Select Unit"
                        className={
                          this.state.fileCreationUnits?.error
                            ? "is-invalid"
                            : ""
                        }
                        /* 🔑 map stored codes → option objects */
                        selected={
                          this.state.unitCode?.options?.filter((item: any) =>
                            this.state.fileCreationUnits?.value?.includes(
                              item.code
                            )
                          ) || []
                        }
                        onChange={(selected: any[]) => {
                          this.setState((prev: any) => ({
                            fileCreationUnits: {
                              ...prev.fileCreationUnits,
                              value: selected.map((item) => item.code), // store codes only
                              error: "",
                            },
                          }));
                        }}
                      />
                    </div>
                  </div>

                  {/* Department */}
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Department</label>
                      <Typeahead
                        id="department-typeahead"
                        multiple
                        labelKey="name"
                        options={this.state.departmentCode?.options || []}
                        placeholder="Select Department"
                        /* 🔑 IMPORTANT FIX */
                        selected={
                          this.state.departmentCode?.options?.filter(
                            (item: any) =>
                              this.state.fileCreationDepartments?.value?.includes(
                                item.code
                              )
                          ) || []
                        }
                        onChange={(selected: any[]) => {
                          this.setState((prev: any) => ({
                            fileCreationDepartments: {
                              ...prev.fileCreationDepartments,
                              value: selected.map((item) => item.code), // 👈 store ONLY codes
                              error: "",
                            },
                          }));
                        }}
                      />
                    </div>
                  </div>

                  {/* Designation */}
                  {/* <div className="col-md-4">
                    <div className="form-group">
                      <label>Designation</label>
                      <Typeahead
                        id="designation-typeahead"
                        multiple
                        labelKey="name"
                        options={this.state.designationCode?.options || []}
                        placeholder="Select Designation"
                        className={
                          this.state.fileCreationDesignations?.error
                            ? "is-invalid"
                            : ""
                        }
                        selected={
                          this.state.designationCode?.options?.filter(
                            (item: any) =>
                              this.state.fileCreationDesignations?.value?.includes(
                                item.code
                              )
                          ) || []
                        }
                        onChange={(selected: any[]) => {
                          this.setState((prev: any) => ({
                            fileCreationDesignations: {
                              ...prev.fileCreationDesignations,
                              value: selected.map((item) => item.code),
                              error: "",
                            },
                          }));
                        }}
                      />
                    </div>
                  </div> */}
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <Link
                      to={CONSTANT.component.adminUserList.url}
                      className="btn btn-block cancel-button btn-sm btn-sm"
                    >
                      Cancel
                    </Link>
                  </div>
                  <div className="col-md-6">&nbsp;</div>
                  <div className="col-md-3">
                    <button
                      type="submit"
                      className="btn btn-block submit-button btn-sm"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  onCompare = function (a: any, b: any) {
    let comparison = 0;
    if (a.name > b.name) {
      comparison = 1;
    } else if (a.name < b.name) {
      comparison = -1;
    }
    return comparison;
  };

  onChange = (e: any) => {
    const st = this.state;
    const name = e.target.name;
    let value = e.target.value;

    if (name === st.isHOD.name) {
      value = value === "true";
    }
    if (name === st.isApprovingAuthority.name) {
      value = value === "true";
    }

    if (name === st.permissionList.name) {
      const checked = e.target.checked;
      const parsedValue = parseFloat(value);
      const permissionValue = JSON.parse(
        JSON.stringify(st.permissionList.value)
      );
      const index = permissionValue.indexOf(parsedValue);
      if (checked) {
        permissionValue.push(parsedValue);
      } else {
        permissionValue.splice(index, 1);
      }
      value = permissionValue;
    }
    onChange(this, name, value);
  };

  typeaheadOnChange = (name: string, e: any) => {
    let value = e;
    if (e.length > 0 && e[0].customOption) {
      value = [{ name: e[0].name }];
    }
    onChange(this, name, value);
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (validateForm(this)) {
      this.setState({ showLoader: true });
      const st = this.state;

      const model: any = {
        employeeNumber: st.employeeNumber.value,
        name: st.name.value,
        email: st.email.value,
        mobile: st.mobile.value,
        isHOD: st.isHOD.value,
        isApprovingAuthority: st.isApprovingAuthority.value,
        designationCode: st.designationCode.value,
        gradeCode: st.gradeCode.value,
        departmentCode: st.departmentCode.value,
        unitCode: st.unitCode.value,
        groupCode: st.groupCode.value,
        userTypeCode: st.userTypeCode.value,
        loginStatusCode: st.loginStatusCode.value,
        reportingManagerCode: st.reportingManagerCode.value,
        dob: st.dob.value,
        doj: st.doj.value,
        contactList: st.contactList.value.map((i: any) => i.code).join(","),
        permissionList: st.permissionList.value.join(","),
        weeklyOff: st.weeklyOff.value.map((i: any) => i.code).join(","),
        leaveAvailingStatusCode: st.leaveAvailingStatusCode.value,
        fileCreationUnits: st.fileCreationUnits?.value,
        fileCreationDepartments: st.fileCreationDepartments?.value,
        fileCreationDesignations: [],
        academicQualifications: st.academicQualifications.value,
        postHeld: st.postHeldName.value,
        postGrade: st.postHeldGrade.value,
        continuousAppointmentDate: st.continuousAppointmentDate.value,
        presentPayScale: st.presentPay.value,
        enterpriseAppointmentDate: st.sameEnterpriseAppointmentDate.value,
        firstPublicEnterpriseDate: st.firstPublicEnterpriseAppointmentDate.value,
        firstAppointmentPayScale: st.firstAppointmentPayScale.value,
      };

      if (st.code) {
        model.code = st.code;
      }

      this.props.onSubmit(model);
    }
  };

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  onCloseModal = () => {
    this.setState({ showModal: false });
  };

  onChangePassword = (model: any) => {
    adminResetPassword(model).then((res: any) => {
      this.onCloseModal();
      if (res.status === CONSTANT.static.apiStatus.success) {
        alert("Password updated successfully");
      } else {
        alert(res.error);
      }
    });
  };
}

export default ComponentName;
